import {environments} from './environments';

export const environment = {
  name: environments.test,
  production: false,
  webApiAddress: 'https://spot.test.packaging-cockpit.com',
  appInsightsConfig: {
    instrumentationKey: '',
  }
};
